import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface StateDataPoint {
  state: string;
  delivered: number;
  read: number;
}

interface PerformanceMapProps {
  data: StateDataPoint[];
}

export default function PerformanceMap({ data }: PerformanceMapProps) {
  const hasData = data.length > 0;
  const maxDelivered = hasData ? Math.max(...data.map((d) => d.delivered)) : 0;

  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-heading font-semibold text-foreground-900 dark:text-foreground-100">Mapa de Desempenho por Estado</h3>
        <span className="text-xs text-foreground-400 bg-background-100 dark:bg-background-200 px-2 py-1 rounded-md">Acumulado</span>
      </div>

      {!hasData ? (
        <div className="h-[380px] flex flex-col items-center justify-center text-foreground-400">
          <i className="ri-map-pin-line text-4xl mb-3" />
          <p className="text-sm font-medium">Sem dados de localização</p>
          <p className="text-xs mt-1">Adicione contatos com estado para ver o mapa de desempenho.</p>
        </div>
      ) : (
        <div className="h-[380px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" barSize={14} barGap={2}>
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-200))" horizontal={false} />
              <XAxis type="number" tick={{ fontSize: 11, fill: 'oklch(var(--foreground-400))' }} axisLine={false} tickLine={false} tickFormatter={(v: number) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v.toString())} />
              <YAxis type="category" dataKey="state" tick={{ fontSize: 12, fill: 'oklch(var(--foreground-600))', fontWeight: 600 }} axisLine={false} tickLine={false} width={36} />
              <Tooltip
                contentStyle={{
                  background: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: 'oklch(var(--foreground-900))',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                }}
                formatter={(value: number) => [value.toLocaleString('pt-BR'), '']}
              />
              <Bar dataKey="delivered" name="Entregues" radius={[0, 6, 6, 0]}>
                {data.map((entry) => (
                  <Cell
                    key={entry.state}
                    fill={entry.delivered === maxDelivered ? 'oklch(var(--accent-500))' : 'oklch(var(--primary-500) / 0.7)'}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}